(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["us-collab-form"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.us-inquiry-form').forEach(function(form){
    var result=form.querySelector('[role="status"], [role="alert"]');
    if(result){result.focus({preventScroll:true});result.scrollIntoView({block:'center'});}
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["us-inquiry-form"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.us-inquiry-form').forEach(function(form){
    var result=form.querySelector('[role="status"], [role="alert"]');
    if(result){result.focus({preventScroll:true});result.scrollIntoView({block:'center'});}
  });
  } catch(e) { console.error(e); }
})();

})();
